<template>
  <div>
    <div class="relative">
      <span class="report_updated_date">データ反映日: {{ activeAccount.reportUpdatedDate }}</span>
    </div>
    <vx-card
      v-if="showSuccessMessage"
      class="mt-12 pb-8"
    >
      <paragraph class="text-center">
        スライドレポートの作成予約が完了しました。

        レポート作成完了次第、メールにてお送りいたします。
        少々お待ちくださいませ。

        しばらくしてもメールが届かない場合、スパムフォルダをご確認ください。
      </paragraph>
    </vx-card>
    <vx-card
      v-else
      class="mt-12"
    >
      <slide-report-form
        v-model:period="period"
        v-model:category="category"
        v-model:report-filters="reportFilters"
        :period-value-options="periods"
        :filter-value-options="filters"
      />
      <vs-button
        class="w-full mt-12"
        @click="onClickSubmit"
      >
        レポート予約
      </vs-button>
    </vx-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Paragraph from '@/components/Paragraph'
import SlideReportForm from '@/components/forms/SlideReportForm'
import { debounce } from '@/utils'

export default {
  name: 'SlideReport',
  components: {
    Paragraph,
    SlideReportForm
  },
  data () {
    return {
      period: 1,
      category: 1,
      reportFilters: [],
      showSuccessMessage: false
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    ...mapState('slideReport', ['periods', 'filters'])
  },
  watch: {
    activeAccount: {
      immediate: true,
      handler (val) {
        if (val) {
          this.reset()
        }
      }
    }
  },
  async mounted () {
    await this.fetchPeriods()
    await this.fetchFilters()
    // 前月と今月の両方がある場合は 今月:2 を選択状態とする
    this.period = (this.periods.periods.length === 2) ? 2 : 1
  },
  methods: {
    ...mapActions('slideReport', ['fetchPeriods', 'fetchFilters', 'addSlideReport']),
    onClickSubmit: debounce(async function () {
      try {
        await this.addSlideReport({
          transactionForm: this.activeAccount.transactionForm,
          period: this.period,
          category: this.category,
          reportFilters: this.reportFilters
        })
        this.showSuccessMessage = true
      } catch (e) {
        console.error(e)
      }
    }, 1000),
    reset () {
      this.period = 1
      this.category = 1
      this.reportFilters = []
    }
  }
}

</script>

<style scoped>
.report_updated_date {
  position: absolute;
  top: -1.75rem;
  right: 0;
  font-size: 1.125rem;
}
</style>
